import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PublicCommited from '../../components/publicCommited/PublicCommited';
import Revenues from '../../components/revenues/Revenues';
import Button from '../../components/buttons/Button';
import StepBar from '../../components/steps-bar/StepsBar';
import RealEstates from '../../components/real-estates/RealEstates';
import Funds from '../../components/funds/Funds';
import OtherCredits from '../../components/other-credits/OtherCredits';
import ReceivablesDeliveriesServices from '../../components/receivables-deliveries-services/ReceivablesDeliveriesServices';
import Heading from './../../components/heading/Heading';
import CheckAndLoss from './../../components/check-and-loss/CheckAndLoss'
import FinancialDataFiles from './../../components/financial-data-files/FinancialDataFiles';

const StepThree = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    let productPrice     = useSelector(state => state.productPrice); 
    let minThreshold     = useSelector(state => state.minThreshold);
    let maxThreshold     = useSelector(state => state.maxThreshold);

    const dispatch = useDispatch()

    useEffect(() => {
        if ( !load ) {
            dispatch({ type: 'STEPS_CHANGE', value: 4 })
            // dispatch({ type: 'PRODUCT_PRICE_CHANGE', value: 11 });
            if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
            }
            setLoad(true);
        } 
    }, [load])

    let prev = () => {
        props.history.push('/krok/3')
    }
    
    let next = async() => {
        await setForceValidate(true)
        await wait(200);
        let errors = await checkErrors();
        await wait(100);

        if ( !errors ) {
            props.history.push('/krok/5')
        } else {
            await setForceValidate(false)
        }
    }
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll('.error-item');
        let elementsRate = document.querySelectorAll('.error');
        if( elements.length > 0  || elementsRate.length > 0) {
            result = true;
            let scrollToTop = elements.length > 0 ? elements[0].offsetTop - 170 : elementsRate[0].offsetTop - 170;
            if ( scrollToTop >= 0 ) {

                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: scrollToTop
                });
            }
        } else {
            result = false;
        }
        return result;
        
    }
    // console.log(productPrice);
    // console.log(minThreshold);
    // console.log(maxThreshold);

    return (
        <>
        <StepBar />
        <section className="form steps">
            <div className="container-step">
                {/* <div className="row" >
                    <PublicCommited forceValidate={ forceValidate } />
                    { productPrice > minThreshold && 
                        <Revenues forceValidate={ forceValidate } />
                    }
                    { productPrice > maxThreshold && 
                    <>
                        <RealEstates/>
                        <Funds />
                        <OtherCredits />
                    </>
                    }
                </div> */}
                <div className="row" >
                    <PublicCommited forceValidate={ forceValidate } />
                    { productPrice > 200000.00  && 
                    <>
                        <RealEstates forceValidate={ forceValidate } />
                        <OtherCredits forceValidate={ forceValidate } />
                        <ReceivablesDeliveriesServices forceValidate={ forceValidate } />
                    </>
                    }

                    {productPrice <= 200000.00 &&
                    <>
                        {productPrice > 50000.00 &&
                        <>
                            <Revenues forceValidate={ forceValidate } />
                            <CheckAndLoss forceValidate={ forceValidate } />
                            {/* <FinancialDataFiles /> */}
                            <RealEstates forceValidate={ forceValidate } />
                            <OtherCredits />
                        </>
                        }
                    </>
                    }
                </div>

                <div className="line" />

                <div className="buttons-row">
                    <div className="col">
                        <Button title="Powrót" class="white reverse margin-reset-mobile" arrowPrevBlue={ true } setFunction={ () => prev() } />
                    </div>
                    <div className="col">
                        <Button title="Dalej" class="blue" arrow={ true } setFunction={ () => next() } />
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default StepThree;